"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedSizes = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
exports.allowedSizes = ["sm", "md", "lg"];
var getPixelsFromSize = function (size) {
    switch (size) {
        case "sm":
            return "24px";
        case "md":
            return "36px";
        case "lg":
            return "48px";
        default:
            return null;
    }
};
var NasdaqIconSvg = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n\n  path {\n    fill: ", ";\n  }\n\n  rect {\n    stroke: ", ";\n  }\n"], ["\n  height: ", ";\n  width: ", ";\n\n  path {\n    fill: ", ";\n  }\n\n  rect {\n    stroke: ", ";\n  }\n"])), function (props) { return getPixelsFromSize(props.size); }, function (props) { return getPixelsFromSize(props.size); }, function (props) { return style_utils_1.colorSelector(props, props.color, props.intensity); }, function (props) { return style_utils_1.colorSelector(props, props.color, props.intensity); });
NasdaqIconSvg.defaultProps = {
    xmlns: "http://www.w3.org/2000/svg",
    size: "md",
    color: "gray",
    intensity: 900
};
exports.default = NasdaqIconSvg;
var templateObject_1;
//# sourceMappingURL=index.js.map